import { useState, useEffect } from 'react'

import axios from 'axios'

function UsePurchases({ initialUrl = '' } = {}) {
  const [data, setData] = useState(null)
  const [url, setUrl] = useState(initialUrl)
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)

  useEffect(() => {
    if (initialUrl && initialUrl !== url) {
      setUrl(initialUrl)
    }
  }, [initialUrl, url])

  useEffect(() => {
    const fetchData = async () => {
      setIsError(false)
      setIsLoading(true)

      try {
        const result = await axios(url)

        setData(result.data)
      } catch (error) {
        setIsError(true)
      }

      setIsLoading(false)
    }

    if (url) {
      fetchData()
    }
  }, [url])

  return [{ data, isLoading, isError }, setUrl]
}

export default UsePurchases
